const About = () => {
  return (
    <div id='about' className='w-full h-auto pt-40 md:h-screen bg-[#0a192f] dark:bg-gray-100 text-gray-300 dark:text-gray-800'>
      <div className='flex flex-col justify-center items-center w-full h-full'>
        <div className='max-w-[1000px] w-full'>
          <div className='absolute -mt-16 pb-8 pl-4'>
            <p className='opacity-10 text-9xl font-bold inline border-b-4 border-yellow-600 dark:text-gray-900' >
              About
            </p>
          </div>
          <br /><br /><br /><br />
        </div>
        <div className='max-w-[1000px] w-full grid sm:grid-cols-2 gap-8 px-4'>
          <div className='sm:text-right text-3xl font-bold'>
            <p>A little bit about me.</p>
          </div>
          <div>
            <p>Well-qualified Full-stack developer familiar with wide range of programming utilities and languages. Knowledgeable of backend and frontend development requirements. Handles any part of process with ease .Collaborative team player with excellent technical abilities offering hands-on experience of multiple project.</p>
            
             
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;